var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invoice"},[_c('h1',[_vm._v("发票,功能开发中...")])])
}]

export { render, staticRenderFns }